import { render, staticRenderFns } from "./TaxCodeSettings.vue?vue&type=template&id=59b9867e&scoped=true&"
import script from "./TaxCodeSettings.vue?vue&type=script&lang=js&"
export * from "./TaxCodeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9867e",
  null
  
)

export default component.exports